const handleTabs = () => {
  const tabs: NodeListOf<HTMLElement> =
    document.querySelectorAll('[data-heading-tab]');
  if (!tabs?.length) return;

  const bodies: NodeListOf<HTMLElement> = document.querySelectorAll(
    '[data-body-tab-item]',
  );
  if (!bodies?.length) return;

  for (const tab of tabs) {
    tab.addEventListener('click', () => {
      for (const tab of tabs) {
        tab.dataset.active = 'false';
      }

      tab.dataset.active = 'true';

      for (const body of bodies) {
        if (body.dataset.anchor === tab.dataset.anchor) {
          body.dataset.active = 'true';
        } else {
          body.dataset.active = 'false';
        }
      }
    });
  }
};

const handleRowsCount = () => {
  const tabs: NodeListOf<HTMLElement> =
    document.querySelectorAll('[data-heading-tab]');
  if (!tabs?.length) return;

  const bodies: NodeListOf<HTMLElement> = document.querySelectorAll(
    '[data-body-tab-item]',
  );
  if (!bodies?.length) return;

  for (const tab of tabs) {
    for (const body of bodies) {
      if (body.dataset.anchor === tab.dataset.anchor) {
        const counter = tab.querySelector('[data-rows-count]');
        const rows = body.querySelectorAll('[data-row]');
        if (counter && rows?.length) {
          counter.textContent = `(${rows.length})`;
        }
      }
    }
  }
};

document.addEventListener('DOMContentLoaded', () => {
  handleRowsCount();
  handleTabs();

  const tab: HTMLElement = document.querySelector('[data-heading-tab]');
  tab?.click();
});
